import { Box, MenuItem, Pagination, Select, SelectChangeEvent, Typography } from "@mui/material";
import React from "react";

export interface PaginationViewProps {
  count: number;
  page: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  rowsPerPage: number;
  handleRowsPerchange: (rows: SelectChangeEvent<number>) => void;
  disabled?: boolean;
}
export const PaginationView: React.FC<PaginationViewProps> = ({
  count,
  page,
  handlePageChange,
  rowsPerPage,
  handleRowsPerchange,
  disabled,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        display: "flex",
        mt: "6px",
        p: 1,
        justifyContent: "space-between",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            pl: "30px",
            fontSize: "14px",
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? "none" : "auto",
          }}
        >
          Show
        </Typography>
        <Select
          size="small"
          sx={{
            mx: "12px",
            height: "24px",
            fontSize: "14px",
            fontWeight: 400,
            p: 1,
            backgroundColor: "#FFFFFF",
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? "none" : "auto",
          }}
          value={rowsPerPage}
          onChange={(event) => handleRowsPerchange(event)}
          displayEmpty
          inputProps={{
            "aria-label": "Without label",
          }}
        >
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
      </Box>
      <Pagination
        count={Math.ceil((count ?? 0) / rowsPerPage)}
        page={page ?? 1}
        onChange={(event, newPage) => handlePageChange(event, newPage)}
        variant="outlined"
        shape="rounded"
        sx={{
          mr: "20px",
          "& .MuiPaginationItem-root": {
            height: "24px",
            color: "gray",
            "&.Mui-selected": {
              backgroundColor: "#4E4E4E",
              color: "white",
            },
          },
          "& .MuiPaginationItem-icon": {
            color: "#E6292E",
          },
        }}
      />
    </Box>
  );
};
